import { render, staticRenderFns } from "./bjThing.vue?vue&type=template&id=1e190bf6&scoped=true"
import script from "./bjThing.vue?vue&type=script&lang=js"
export * from "./bjThing.vue?vue&type=script&lang=js"
import style0 from "./bjThing.vue?vue&type=style&index=0&id=1e190bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e190bf6",
  null
  
)

export default component.exports